const EXPERIMENT_OVERRIDE_CACHE_KEY = "userExperimentOverrides";

export const getExperimentOverride = (experimentName: string) => {
  try {
    const stateString = localStorage.getItem(EXPERIMENT_OVERRIDE_CACHE_KEY);
    if (stateString) {
      const json = JSON.parse(stateString);
      return json[experimentName];
    }
  } catch (_e) {
    // Do nothing.
  }
  return null;
};

export const getAllExperimentOverrides = () => {
  const overrides = localStorage.getItem(EXPERIMENT_OVERRIDE_CACHE_KEY);
  if (overrides) {
    return JSON.parse(overrides);
  }
  return {};
};

export const resetExperimentOverrides = () => {
  localStorage.setItem(EXPERIMENT_OVERRIDE_CACHE_KEY, JSON.stringify({}));
};

export const setExperimentOverride = (
  experimentName: string,
  segmentValue: string,
) => {
  const overridesString = localStorage.getItem(EXPERIMENT_OVERRIDE_CACHE_KEY);
  const overrides = overridesString ? JSON.parse(overridesString) : {};
  const newOverrides = {
    ...overrides,
    [experimentName]: segmentValue,
  };
  localStorage.setItem(
    EXPERIMENT_OVERRIDE_CACHE_KEY,
    JSON.stringify(newOverrides),
  );
};
